import React, { Fragment } from 'react';
// import Table from '@material-ui/core/Table';
// import MuiTableCell from '@material-ui/core/TableCell';
// import TableRow from '@material-ui/core/TableRow';
import {
  makeStyles,
  createStyles,
  // withStyles
} from '@material-ui/core/styles';
import GetAppIcon from '@material-ui/icons/GetApp';
import Button from '@material-ui/core/Button';
// import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas';
// import logo from '../images/OneCart.svg';
// import login from '../images/login.jpg';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import buildersLogo from '../images/buildersLogoBase64';

pdfMake.vfs = pdfFonts.pdfMake.vfs;
const dateToString = (date, includeDate = true, includeTime = true) => {
  // Using this format to avoid UTC changes, using toISOString() and substringing will potentially cause issues with timezones causing the date to be 1 day behind
  let dateString = includeDate
    ? padLeft(date.getFullYear() + '', '0', 4) +
    '-' +
    padLeft(date.getMonth() + 1 + '', '0', 2) +
    '-' +
    padLeft(date.getDate() + '', '0', 2)
    : '';

  if (dateString.length && includeTime) {
    dateString += ' ';
  }

  dateString += includeTime
    ? padLeft(date.getHours() + '', '0', 2) +
    ':' +
    padLeft(date.getMinutes() + '', '0', 2) +
    ':' +
    padLeft(date.getSeconds() + '', '0', 2)
    : '';
  return dateString;
};

const padLeft = (value, padChar, padLength) => {
  // get the pad character
  padChar = padChar[0] || ' ';

  // add the padChar until the length of value is the desired length or bigger
  while (value.length < padLength) {
    value = padChar + value;
  }

  // return the padded result
  return value;
};
const useStyles = makeStyles((theme) =>
  createStyles({
    invoiceBox: {
      maxWidth: '800px',
      margin: 'auto',
      padding: '30px',
      border: '1px solid #eee',
      boxShadow: '0 0 10px rgba(0, 0, 0, .15)',
      fontSize: '16px',
      lineHeight: '24px',
    },
    productCell: {
      paddingBottom: '0px',
      paddingTop: '0px',
    },
    button: {
      margin: theme.spacing(1),
      borderRadius: theme.spacing(1),
    },
    call: {
      marginTop: theme.spacing(3),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    totals: {
      float: 'left',
    },
    tableHeader: {},
  })
);

const buildTableBody = (data) => {
  const tableHeaderColumns = [
    { text: 'Description', style: 'tableHeader', fontSize: 11, margin: [0, 4, 0, 2] },
    { text: 'Qty', style: 'tableHeader', fontSize: 11, margin: [0, 4, 0, 2], alignment: 'center' },
    { text: 'Vat %', style: 'tableHeader', fontSize: 11, margin: [0, 4, 0, 2] },
    { text: 'Price per\nunit', style: 'tableHeader', fontSize: 12, margin: [0, 4, 0, 2] },
    { text: 'Total', style: 'tableHeader', fontSize: 11, margin: [0, 4, 0, 2] },
  ]

  const body = [];

  body.push(tableHeaderColumns);

  data.forEach((row) => {
    if (row.product !== "Delivery Fee") {
      const productRow = [
        { text: `${row.product}`, fontSize: 10, margin: [0, 1, 0, 2] },
        { text: `${row.quantity}`, fontSize: 10, margin: [0, 1, 0, 2], alignment: 'center' },
        { text: `${row.percentageVat}%`, fontSize: 10, margin: [0, 1, 0, 2] },
        { text: `${row.priceExcVat.toFixed(2)}`, fontSize: 10, margin: [0, 1, 0, 2] },
        { text: `R${row.total.toFixed(2)}`, fontSize: 10, margin: [0, 1, 0, 2] },
      ];
      body.push(productRow);
    }
  });



  return body;
}

const table = (data) => {
  return {
    layout: 'noBorders', // optional
    table: {
      headerRows: 1,
      widths: [200, '*', '*', '*', '*'],

      body: buildTableBody(data)
    }
  };
}

const BUILDERS_PAGE_SIZE = 'A4';
const BUILDERS_PAGE_MARGINS = [33, 33, 33, 33];
const BUILDERS_TABLE_COLUMNS = {
  description: '*',
  quantity: 58,
  vat: 42,
  price: 95,
  total: 65,
  gap: 12,
};
const BUILDERS_DIVIDER_WIDTH = 3;
// Convert px (96dpi) to PDF pt (72dpi).
const pdfPoints = (px) => px * 0.75;
const BUILDERS_TABLE_ROW_MARGIN = [0, 0, 0, pdfPoints(20)];

const BUILDERS_TYPE = {
  taxInvoice: { size: pdfPoints(24), bold: true },
  body: { size: pdfPoints(14), bold: false },
  bodySemiBold: { size: pdfPoints(14), bold: true },
  invoiceNumber: { size: pdfPoints(16), bold: true },
  sectionTitle: { size: pdfPoints(18), bold: true },
  tableHeader: { size: pdfPoints(18), bold: true },
  tableRow: { size: pdfPoints(14), bold: false },
  totalsRow: { size: pdfPoints(14), bold: true },
  totalsFinalLabel: { size: pdfPoints(20), bold: true },
  totalsFinalValue: { size: pdfPoints(16), bold: true },
};

const buildersText = (text, style, options = {}) => ({
  text,
  fontSize: style.size,
  bold: style.bold,
  ...options,
});

const createBorderedBlock = (innerContent, verticalPadding = 15) => ({
  margin: [0, 0, 0, 0],
  table: {
    widths: ['*'],
    body: [[innerContent]],
  },
  layout: {
    hLineWidth(i, node) {
      return i === 0 || i === node.table.body.length ? BUILDERS_DIVIDER_WIDTH : 0;
    },
    vLineWidth() {
      return 0;
    },
    hLineColor() {
      return '#000000';
    },
    paddingLeft() {
      return 0;
    },
    paddingRight() {
      return 0;
    },
    paddingTop() {
      return verticalPadding;
    },
    paddingBottom() {
      return verticalPadding;
    },
  },
});

const createBottomBorderedBlock = (innerContent, paddingTop = 15, paddingBottom = 30, marginTop = 0) => ({
  margin: [0, marginTop, 0, 0],
  table: {
    widths: ['*'],
    body: [[innerContent]],
  },
  layout: {
    hLineWidth(i, node) {
      return i === node.table.body.length ? BUILDERS_DIVIDER_WIDTH : 0;
    },
    vLineWidth() {
      return 0;
    },
    hLineColor() {
      return '#000000';
    },
    paddingLeft() {
      return 0;
    },
    paddingRight() {
      return 0;
    },
    paddingTop() {
      return paddingTop;
    },
    paddingBottom() {
      return paddingBottom;
    },
  },
});

const formatCurrency = (amount) => `R ${Number(amount || 0).toFixed(2)}`;

const buildBuildersTableRow = (cells, style, options = {}) => ({
  columns: [
    { width: BUILDERS_TABLE_COLUMNS.description, ...buildersText(cells[0], style) },
    {
      width: BUILDERS_TABLE_COLUMNS.quantity,
      ...buildersText(cells[1], style, { noWrap: true }),
    },
    {
      width: BUILDERS_TABLE_COLUMNS.vat,
      ...buildersText(cells[2], style, { noWrap: true }),
    },
    {
      width: BUILDERS_TABLE_COLUMNS.price,
      ...buildersText(cells[3], style, { noWrap: true }),
    },
    {
      width: BUILDERS_TABLE_COLUMNS.total,
      ...buildersText(cells[4], style, { noWrap: true }),
    },
  ],
  columnGap: BUILDERS_TABLE_COLUMNS.gap,
  margin: options.margin || BUILDERS_TABLE_ROW_MARGIN,
});

const buildersTable = (data) => {
  const rows = [
    buildBuildersTableRow(
      ['Description', 'Quantity', 'Vat %', 'Price per unit', 'Total'],
      BUILDERS_TYPE.tableHeader,
      { margin: [0, pdfPoints(20), 0, pdfPoints(24)] }
    ),
  ];

  data.forEach((row) => {
    if (row.product !== 'Delivery Fee') {
      rows.push(
        buildBuildersTableRow(
          [
            row.product,
            `${row.quantity}`,
            `${row.percentageVat}%`,
            row.priceExcVat.toFixed(2),
            formatCurrency(row.total),
          ],
          BUILDERS_TYPE.tableRow
        )
      );
    }
  });

  return { stack: rows };
};

const buildBuildersTotalsSection = (invoice) => {
  const subtotal =
    invoice.items
      ?.filter((row) => row.product !== 'Delivery Fee')
      .reduce((sum, row) => sum + row.total, 0) ||
    invoice.subtotal - (invoice.deliveryFee || 0);
  const discount = invoice.discount || 0;
  const vat = invoice.vatSum || 0;
  const total = invoice.subtotal;

  const totalRow = (label, value, options = {}) => ({
    columns: [
      {
        width: '*',
        ...buildersText(label, options.labelStyle || BUILDERS_TYPE.totalsRow),
      },
      {
        width: 80,
        ...buildersText(formatCurrency(value), options.valueStyle || BUILDERS_TYPE.totalsRow, {
          alignment: 'right',
          noWrap: true,
        }),
      },
    ],
    margin: [0, 0, 0, 8],
  });

  return [
    totalRow('Subtotal', subtotal),
    totalRow('Discount', discount),
    totalRow('VAT', vat),
    totalRow('Total', total, {
      labelStyle: BUILDERS_TYPE.totalsFinalLabel,
      valueStyle: BUILDERS_TYPE.totalsFinalValue,
    }),
  ];
};

const buildBuildersInvoice = (invoice) => ({
  pageSize: BUILDERS_PAGE_SIZE,
  pageMargins: BUILDERS_PAGE_MARGINS,
  content: [
    {
      columns: [
        [
          buildersText('TAX INVOICE', BUILDERS_TYPE.taxInvoice, { margin: [0, 0, 0, 12] }),
          buildersText(
            [
              'Builders a division of Massmart Retail (Pty) Ltd.',
              '\n',
              'Reg No.: 2008/011666/07',
              '\n',
              '16 Peltier Avenue, Sunninghill,',
              '\n',
              'Sandton, 2157',
              '\n',
              '\n',
              'VAT No: 4880254414',
              '\n',
              'Please retain as proof of purchase',
            ],
            BUILDERS_TYPE.body,
            { lineHeight: 1.43 }
          ),
        ],
        {
          width: 180,
          stack: [
            {
              image: buildersLogo,
              width: 130,
              alignment: 'right',
              margin: [0, 0, 0, 12],
            },
            buildersText(
              `Invoice number: ${invoice.invoiceNumber || invoice.orderID}`,
              BUILDERS_TYPE.invoiceNumber,
              { alignment: 'right' }
            ),
          ],
        },
      ],
      margin: [0, 0, 0, pdfPoints(44)],
    },
    createBorderedBlock(
      {
        columns: [
          {
            width: '*',
            stack: [
              buildersText(invoice.shipping.name.toUpperCase(), BUILDERS_TYPE.sectionTitle, {
                margin: [0, 0, 0, 8],
              }),
              buildersText(
                [invoice.shipping.address, '\n', invoice.shipping.city, '\n', invoice.shipping.postalCode],
                BUILDERS_TYPE.body,
                { lineHeight: 1.43 }
              ),
            ],
          },
          {
            width: 180,
            stack: [
              buildersText(
                [{ text: 'Order Number: ', bold: true }, `${invoice.orderID}`],
                BUILDERS_TYPE.body,
                { alignment: 'right', margin: [0, 0, 0, 4] }
              ),
              buildersText(
                [
                  { text: 'Date of Order: ', bold: true },
                  `${dateToString(new Date(invoice.dateOfOrder), true, false)}`,
                ],
                BUILDERS_TYPE.body,
                { alignment: 'right', margin: [0, 0, 0, 4] }
              ),
              buildersText(
                [{ text: 'Date of Invoice: ', bold: true }, `${dateToString(new Date(), true, false)}`],
                BUILDERS_TYPE.body,
                { alignment: 'right', margin: [0, 0, 0, 4] }
              ),
              buildersText(
                [
                  { text: 'Delivery Date: ', bold: true },
                  `${dateToString(new Date(invoice.deliveryDate), true, false)}`,
                ],
                BUILDERS_TYPE.body,
                { alignment: 'right' }
              ),
            ],
          },
        ],
      },
      15
    ),
    buildersTable(invoice.items),
    createBorderedBlock(
      {
        stack: buildBuildersTotalsSection(invoice),
      },
      24
    ),
    createBottomBorderedBlock(
      {
        stack: [
          buildersText('Contact Us', BUILDERS_TYPE.sectionTitle, { margin: [0, 0, 0, pdfPoints(16)] }),
          buildersText(
            'For any assistance, please contact us below for a prompt response.',
            BUILDERS_TYPE.body
          ),
          {
            columns: [
              {
                width: 'auto',
                ...buildersText([{ text: 'Call Center: ', bold: true }, '086 028 4533'], BUILDERS_TYPE.body),
              },
              {
                width: 'auto',
                ...buildersText(
                  [{ text: 'Email: ', bold: true }, 'buildersnow@builders.co.za'],
                  BUILDERS_TYPE.body
                ),
              },
            ],
            columnGap: 12,
            margin: [0, pdfPoints(24), 0, 0],
          },
        ],
      },
      pdfPoints(20),
      pdfPoints(40),
      pdfPoints(40)
    ),
  ],
  defaultStyle: {
    color: '#000000',
  },
});



const Invoice = (props) => {
  const { data } = props;

  const classes = useStyles();
  // const invoiceRef = React.createRef();
  const invoice = data?.data?.details;
  if (invoice) {
    invoice.conciergeFee = 0;
  }
  // invoice.subTotal = invoice.subtotal - invoice.deliveryFee;
  // invoice.total = invoice.subtotal + invoice.conciergeFee;

  const oneCartInvoice = {
    content: [
      {
        columns: [
          [
            {
              text: [
                {
                  text: 'ONECART',
                  color: '#57a946',
                  fontSize: 18,
                  bold: true,
                  alignment: 'left',
                  margin: [0, 0, 0, 0],
                },
              ],
            },
            {
              text: 'TAX INVOICE',
              color: '#333333',
              fontSize: 14,
              margin: [0, 20, 0, 10],
              bold: true
            },
            {
              text: [
                'OneCart (Pty) Ltd (Reg. No 2016 / 262246 / 07)',
                '\n',
                '2nd Floor, Norwich Place Sandton',
                '\n',
                'Johannesburg',
                '\n',
                'Gauteng 2196, ZA',
              ],
              fontSize: 10,
              lineHeight: 1.2,
              margin: [0, 0, -15, 0],
            },
            {
              text: ['Vat Registration: 4680283324', '\n', 'Please retain as proof of purchase', '\n'],
              fontSize: 10,
              lineHeight: 1.2,
              margin: [0, 10, -15, 0],
            },
          ],
          {
            stack: [
              {
                image:
                  'data:image/png;base64,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',
                width: 100,
                style: 'logo',
              },
              { text: `Invoice number: ${invoice.orderID}`, style: 'invoiceNumber' },
            ],
          },
        ],
      },
      '\n',
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 3, lineColor: '#57a946' }] },
      '\n',
      {
        text: `${invoice.shipping.name.toUpperCase()}`,
        bold: true,
        margin: [0, 0, 0, 5],
        fontSize: 10,
      },

      {
        columns: [
          {
            stack: [
              { text: `${invoice.shipping.address}`, fontSize: 10 },
              { text: `${invoice.shipping.city}`, fontSize: 10, },
              { text: `${invoice.shipping.postalCode}`, fontSize: 10, },
            ],
            margin: [0, 0, 0, 10],
          },

          {
            stack: [
              {
                columns: [
                  {
                    // auto-sized columns have their widths based on their content
                    width: 'auto',
                    text: [
                      {
                        text: 'Order Number:  ',
                        bold: true,
                        fontSize: 10,
                      },
                      {
                        text: `${invoice.orderID}`,
                        fontSize: 10,
                      },
                    ],
                  },
                ],
              },
              {
                columns: [
                  {
                    // auto-sized columns have their widths based on their content
                    width: 'auto',
                    text: [
                      {
                        text: 'Date of Order:  ',
                        bold: true,
                        fontSize: 10,
                      },
                      {
                        text: `${dateToString(new Date(invoice.dateOfOrder), true, false)}`,
                        fontSize: 10,
                      },
                    ],
                  },
                ],
              },
              {
                columns: [
                  {
                    // auto-sized columns have their widths based on their content
                    width: 'auto',
                    text: [
                      {
                        text: 'Date of invoice:  ',
                        bold: true,
                        fontSize: 10,
                      },
                      {
                        text: `${dateToString(new Date(), true, false)}`,
                        fontSize: 10,
                      },
                    ],
                  },
                ],
              },
              {
                columns: [
                  {
                    // auto-sized columns have their widths based on their content
                    width: 'auto',
                    text: [
                      {
                        text: 'Delivery Date:  ',
                        bold: true,
                        fontSize: 10,
                      },
                      {
                        text: `${dateToString(new Date(invoice.deliveryDate), true, false)}`,
                        fontSize: 10,
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
        columnGap: 100,
      },
      '\n',

      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 3, lineColor: '#57a946' }] },
      '\n',
      table(invoice.items),
      '\n',
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 3, lineColor: '#57a946' }] },
      '\n',
      {
        columns: [
          {
            width: 200,
            text: 'Subtotal',
            fontSize: 10,
            bold: true,
          },
          {
            width: '*',
            text: '',
            fontSize: 10,
          },
          {
            width: '*',
            text: '',
            fontSize: 10,
          },

          {
            width: '*',
            text: ``,
            fontSize: 10,
          },

          {
            width: '*',
            text: `R ${(invoice.subtotal - invoice.deliveryFee).toFixed(2)}`,
            fontSize: 10,
          },
        ],
      },
      '\n',
      // {
      //   columns: [
      //     {
      //       width: 200,
      //       text: 'Delivery fee',
      //       fontSize: 10,
      //       bold: true,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },

      //     {
      //       width: '*',
      //       text: ``,
      //       fontSize: 10,
      //     },

      //     {
      //       width: '*',
      //       text: `R ${invoice.deliveryFee.toFixed(2)}`,
      //       fontSize: 10,
      //     },
      //   ],
      // },
      // '\n',

      // {
      //   columns: [
      //     {
      //       width: 200,
      //       text: 'Service fee',
      //       fontSize: 10,
      //       bold: true,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },

      //     {
      //       width: '*',
      //       text: ``,
      //       fontSize: 10,
      //     },

      //     {
      //       width: '*',
      //       text: `R ${invoice.conciergeFee.toFixed(2)}`,
      //       fontSize: 10,
      //     },
      //   ],
      // },
      // '\n',
      // {
      //   columns: [
      //     {
      //       width: 200,
      //       text: 'Goods purchased from OneCart as an Agent',
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },

      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: `R ${invoice.subtotal.toFixed(2)}`,
      //       fontSize: 10,
      //     },
      //   ],
      // },
      // '\n',
      // {
      //   columns: [
      //     {
      //       width: 200,
      //       text: 'Total',
      //       bold: true,
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },
      //     {
      //       width: '*',
      //       text: '',
      //       fontSize: 10,
      //     },
      //     {
      //       bold: true,
      //       width: '*',
      //       text: `R ${(invoice.subtotal - invoice.deliveryFee).toFixed(2)}`,
      //       fontSize: 10,
      //     },
      //   ],
      // },
      // '\n',
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 3, lineColor: '#57a946' }] },
      '\n',
      {
        text: 'Contact Us',
        style: 'notesTitle',
        fontSize: 10,
      },
      {
        text: 'For any assistance please contact us below for a prompt responce.',
        margin: [0, 0, 0, 15],
        fontSize: 10,
      },

      {
        columns: [
          {
            // auto-sized columns have their widths based on their content
            width: 'auto',
            text: [
              {
                text: 'Call Center:',
                fontSize: 10,
              },
              {
                text: ' 010 476 1400',
                bold: true,
                fontSize: 10,
              },
            ],
          },
          {
            // auto-sized columns have their widths based on their content
            width: 'auto',
            text: [{ text: 'Email: ' }, { text: ' orders@onecart.co.za', bold: true }],
            fontSize: 10,
          },
        ],
        columnGap: 30,
      },
      '\n',
      { canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 3, lineColor: '#57a946' }] },
      '\n',
    ],
    styles: {
      logo: {
        bold: true,
        alignment: 'right',
        margin: [0, 0, 0, 0],
      },
      invoiceNumber: {
        alignment: 'right',
        margin: [0, 5, 0, 0],
        fontSize: 10,
      },
      notesTitle: {
        fontSize: 12,
        bold: true,
        margin: [0, 5, 0, 3],
        lineHeight: 1.3,
      },
      tableHeader: { bold: true },
      notesText: {
        fontSize: 10,
        lineHeight: 1.3,
        margin: [0, 0, 0, 3],
      },
    },
  };

  // const isBuildersInvoice = orderTypeID === OrderTypes.BUILDERS;
  // TODO: Remove this if the builders store is back online
  const isBuildersInvoice = false;

  const printInvoicePdf = () => {
    if (!invoice) return;

    const invoiceDocument = isBuildersInvoice ? buildBuildersInvoice(invoice) : oneCartInvoice;
    pdfMake.createPdf(invoiceDocument).download();
  };

  return (
    <Fragment>
      <div className={classes.call}>
        <Button
          onClick={printInvoicePdf}
          size="large"
          variant="outlined"
          className={classes.button}
          startIcon={<GetAppIcon color="primary" />}
        >
          Download Invoice
        </Button>
      </div>
    </Fragment>
  );
};

export default Invoice;
